module.exports = __webpack_public_path__ + "img/new_firebolt.75b7feff.jpg";